import {
  SET_BACKGROUND_LIST,
  SET_BACKGROUND_QUERY,
  SET_BACKGROUND_SEARCHING,
  SET_BACKGROUND_LIST_PAGE_SIZE,
  SET_BACKGROUND_PAGE_COUNT,
  SET_BACKGROUND_LIST_TOTAL,
} from './mutation-types'
import api from '@/api'
import { objectTrim } from '@/utils'
const initQuery = {
  title: '',
  terminals: '',
  pageSize: 10,
  pageNum: 1,
}

const state = {
  list: [],
  query: initQuery,
  searching: false,
  total: 0,
}

const mutations = {
  [SET_BACKGROUND_LIST](state, payload) {
    state.list = payload
  },
  [SET_BACKGROUND_QUERY](state, payload) {
    state.query = {
      ...state.query,
      ...payload,
    }
  },
  [SET_BACKGROUND_SEARCHING](state, payload) {
    state.searching = payload
  },
  [SET_BACKGROUND_PAGE_COUNT](state, payload) {
    state.query.pageNum = payload
  },
  [SET_BACKGROUND_LIST_TOTAL](state, payload) {
    state.total = payload
  },
  [SET_BACKGROUND_LIST_PAGE_SIZE](state, payload) {
    state.query.pageSize = payload
  },
}

const actions = {
  async getBackgroundList({ commit, state }) {
    try {
      commit(SET_BACKGROUND_SEARCHING, true)
      let { data } = await api.deployApi.getBackgroundList(objectTrim(state.query))
      commit(SET_BACKGROUND_SEARCHING, false)
      const { items: list, total } = data
      commit(SET_BACKGROUND_LIST_TOTAL, total)
      commit(SET_BACKGROUND_LIST, list || [])
    } catch (error) {
      commit(SET_BACKGROUND_LIST, [])
      commit(SET_BACKGROUND_LIST_TOTAL, 0)
    }
  },
  async initBackgroundList({ dispatch }) {
    await dispatch(SET_BACKGROUND_QUERY, state.initQuery)
    await dispatch('getBackgroundList')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
